export default (data) => ({
  type: 'UPDATE_FILTER',
  payload: data,
});
